import React from 'react';
import { Box, CircularProgress, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const styles = {
    container: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f6f5f6'
    }
};

const LoadingView = ({ classes }) => {
    return (
        <Box className={classes.container}>
            <CircularProgress />
        </Box>
    );
};

LoadingView.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(LoadingView);
